import styled from 'styled-components'
import {
  flexbox,
  FlexboxProps,
  flexDirection,
  FlexDirectionProps,
  margin,
  MarginProps,
  padding,
  PaddingProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  FlexboxProps & GapProps & PaddingProps & MarginProps
>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  border-radius: 20px;
  overflow: hidden;

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  button,
  p,
  div {
    z-index: 2;
  }

  svg {
    color: ${themeGet('colors.text.inverse')};
  }

  ${flexbox}
  ${gap}
  ${padding}
  ${margin}
`

export const Title = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;

  > svg {
    width: 30px;
    height: 30px;
  }

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    > svg {
      width: 35px;
      height: 35px;
    }
  }

  ${flexDirection}
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: ${themeGet('gradients.imageOverlay.primary')};
`
